import script from "./AddAddressModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAddressModal.vue?vue&type=script&setup=true&lang=js"

import "./AddAddressModal.vue?vue&type=style&index=0&id=10ac0637&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ac0637"]])

export default __exports__